export const DEFAULT_API_URL =
  'https://raw.githubusercontent.com/stoplightio/elements/main/demo/src/reference/todo.v1.yaml';

export const EXAMPLE_SPECS = [
  {
    text: 'Todo API (default example)',
    value: 'https://raw.githubusercontent.com/stoplightio/elements/main/demo/src/reference/todo.v1.yaml',
  },
  {
    text: 'Zoom',
    value: 'https://raw.githubusercontent.com/stoplightio/Public-APIs/master/reference/zoom/openapi.yaml',
  },
  {
    text: 'Digital Ocean',
    value: 'https://raw.githubusercontent.com/digitalocean/openapi/main/specification/DigitalOcean-public.v2.yaml',
  },
  {
    text: 'Box',
    value: 'https://raw.githubusercontent.com/box/box-openapi/main/content/openapi.yml',
  },
  {
    text: 'CircleCI',
    value: 'https://api.apis.guru/v2/specs/circleci.com/v1/openapi.yaml',
  },
  {
    text: 'GitHub',
    value: 'https://raw.githubusercontent.com/github/rest-api-description/main/descriptions/ghes-3.0/ghes-3.0.json',
  },
  {
    text: 'Linode',
    value: 'https://api.apis.guru/v2/specs/linode.com/4.97.2/openapi.yaml',
  },
  {
    text: 'Netlify',
    value: 'https://raw.githubusercontent.com/stoplightio/Public-APIs/master/reference/netlify/openapi.yaml',
  },
  {
    text: 'NY Times Article Search',
    value: 'https://api.apis.guru/v2/specs/nytimes.com/article_search/1.0.0/openapi.yaml',
  },
  {
    text: 'Plaid',
    value: 'https://raw.githubusercontent.com/stoplightio/Public-APIs/master/reference/plaid/openapi.yaml',
  },
  {
    text: 'Instagram',
    value: 'https://api.apis.guru/v2/specs/instagram.com/1.0.0/swagger.yaml',
  },
  {
    text: 'Cloudflare API',
    value: 'https://developers.cloudflare.com/schema',
  },
];
